import React from "react";
import PageWrapper from "../components/PageWrapper";
import "./css/Contact.css"; // Reusing existing styles
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <title>
          About Us | GTAFanPage.com – GTA 6 Fan Community & News Hub
        </title>
        <meta
          name="description"
          content="Learn about GTAFanPage.com – a fan-powered hub for GTA 6 news, leaks, and community content. Discover our mission and disclaimer."
        />
        <link rel="canonical" href="https://www.gtafanpage.com/about-us" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="About GTAFanPage.com" />
        <meta
          property="og:description"
          content="GTAFanPage.com is a community-driven project for fans of Grand Theft Auto. Explore our story, purpose, and how to get involved."
        />
        <meta property="og:url" content="https://www.gtafanpage.com/about-us" />
        <meta
          property="og:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | GTAFanPage.com" />
        <meta
          name="twitter:description"
          content="Get to know the GTAFanPage.com team and our mission to unite fans around Grand Theft Auto 6 and the entire GTA universe."
        />
        <meta
          name="twitter:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* Optional JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "GTAFanPage",
            url: "https://www.gtafanpage.com",
            logo: {
              "@type": "ImageObject",
              url: "https://www.gtafanpage.com/logo192.png",
            },
            description:
              "GTAFanPage.com is a fan-operated news and community platform dedicated to Grand Theft Auto.",
            sameAs: [
              "https://twitter.com/GTAFanPage",
              "https://www.youtube.com/@RockstarGames",
            ],
          })}
        </script>
      </Helmet>

      <PageWrapper>
        <div className="contact-page-wrapper">
          <div className="contact-card">
            <h2>About GTAFanPage.com</h2>
            <p>
              Welcome to <strong>GTAFanPage.com</strong> — your go-to hub for
              all things Grand Theft Auto! This fan-driven website is created by
              gamers, for gamers, to celebrate the excitement and legacy of the
              Grand Theft Auto series.
            </p>
            <p>
              Here, you'll find news, updates, rumors, fan theories, gameplay
              discussions, polls, and community posts surrounding the highly
              anticipated <strong>GTA 6</strong> and other titles in the
              franchise.
            </p>
            <p>
              Whether you're reliving iconic moments from Vice City or analyzing
              trailers frame by frame, our community is a space where fans can
              come together and share their passion for Rockstar’s open-world
              masterpiece.
            </p>
            <p>
              <strong>Disclaimer:</strong> GTAFanPage.com is an independent fan
              project and is not affiliated with, endorsed, or sponsored by
              Rockstar Games or Take-Two Interactive.
            </p>
            <p>
              Got suggestions, questions, or feedback? Reach out to us at{" "}
              <Link to="/contact" className="contact-link">
                Contact Us
              </Link>{" "}
              to send us a message.
            </p>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default About;
